import { render, staticRenderFns } from "./VaultDetails.vue?vue&type=template&id=3e89635c"
import script from "./VaultDetails.vue?vue&type=script&lang=js"
export * from "./VaultDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports